import { Col, Footer, Picture, Row, Button, Banner, Typography } from 'darrius';

import { Header } from '../../components/atoms';
import { HeadContent } from '../../components';

import { triggerEvent } from '../../utils/triggerEvent';

import { type ISuccessTemplateProps } from './@interfaces';

import styles from './SucessTemplate.module.scss';

export default function SuccessTemplate({
  staticContent,
  buttonLink,
}: ISuccessTemplateProps) {
  const { footerContent } = staticContent;

  function handleTriggerButtonEvent(label: string) {
    triggerEvent('sucess_template-buttom_click-ab_test', {
      label,
    });
  }

  return (
    <>
      <HeadContent
        metaTitle="GetNinjas | Orçamento de Profissionais Confiáveis no GetNinjas.com.br"
        slug="Anuncie"
        metaDescription="Encontre profissionais confiáveis para pintar, reformar, traduzir um texto, te ensinar matemática, ou também passear com seu cachorro no GetNinjas"
        type="page:register-success"
      />

      <Header.Simple />

      <main
        className={`register-success space-top space-bottom ${styles['register-success']}`}
      >
        <Banner>
          <Row className="center-sm">
            <Col className="col-sm-5 col-md-2">
              <Picture
                className="full"
                src={{
                  sm: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/pro-illustration.svg`,
                  md: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/pro-illustration.svg`,
                  lg: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/pro-illustration.svg`,
                }}
              />
            </Col>
          </Row>

          <Row className="center-sm">
            <Col className="col-md-6">
              <Typography.Title size="3xl">
                Enviamos um SMS para você
              </Typography.Title>
              <Typography.Text className={styles.text}>
                Faça o download do aplicativo, compre moedas, escolha seus
                pedidos e feche muitos negócios!
              </Typography.Text>
            </Col>
          </Row>

          <Row className="center-sm space-between">
            <Col className="col-sm-12 col-md-4">
              <Button.Link
                href={buttonLink}
                variation="primary"
                size="small"
                fullWidth
                onClick={() => handleTriggerButtonEvent('app_download')}
              >
                Continue no aplicativo
                <Button.Icon name="MdChevronRight" size={25} />
              </Button.Link>
            </Col>

            <Col className="col-sm-12 col-md-4">
              <Button.Link
                href="/seja-um-profissional/cadastro?no-pre_signup=true"
                variation="secondary"
                size="small"
                fullWidth
                onClick={() => handleTriggerButtonEvent('complete_profile')}
              >
                Concluir cadastro agora
              </Button.Link>
            </Col>
          </Row>
        </Banner>
      </main>

      <Footer data={footerContent} />
    </>
  );
}
